var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 m-0 line-height-1 font-weight-bolder bg-light theme-settings-header app-map-point-panel-header"},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.header))]})],2),_c('div',{staticClass:"app-map-point-panel-close",on:{"click":_vm.close}},[_c('i',{staticClass:"ion ion-md-close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }